import { render, staticRenderFns } from "./personal-information-resource-item-5-currency-exchange-information-settings.vue?vue&type=template&id=4c59f906&scoped=true&"
import script from "./personal-information-resource-item-5-currency-exchange-information-settings.vue?vue&type=script&lang=ts&"
export * from "./personal-information-resource-item-5-currency-exchange-information-settings.vue?vue&type=script&lang=ts&"
import style0 from "./personal-information-resource-item-5-currency-exchange-information-settings.vue?vue&type=style&index=0&id=4c59f906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59f906",
  null
  
)

export default component.exports